/**
 * Storage key constants for localStorage and sessionStorage.
 * These keys are used across AuthModule and BrowserModule for managing
 * authentication state and persisted data.
 */

// localStorage keys
export const STORAGE_KEY_SERVICE_ID = 'serviceId';
export const STORAGE_KEY_SERVICE_NAME = 'serviceName';
export const STORAGE_KEY_REFRESHED_AT = 'refreshedAt';
export const STORAGE_KEY_TASKS = 'tasks';

// sessionStorage keys
export const STORAGE_KEY_AUTH_RESPONSE = 'auth_response';
export const STORAGE_KEY_AUTH_REDIRECT_URL = 'auth_redirect_url';

// localStorage key prefix (used by @openid/appauth library)
export const STORAGE_PREFIX_APPAUTH = 'appauth_';
